import dayjs from 'dayjs';
import type { TypeEvent } from '@/types/calendar/types.calendar';

export const REMINDER_SPAN_MINUTES = 15;

export const isReminder = (event: TypeEvent | null | undefined): boolean => event?.kind === 'reminder';

export function isOpenReminder(event: TypeEvent, until: Date): boolean {
    return event.kind === 'reminder' && event.status === 'planned' && !event.recurrence && Date.parse(event.startAt) < until.getTime();
}

export function reminderLateDays(event: TypeEvent, now: Date): number {
    if (event.status !== 'planned') return 0;
    const days = dayjs(now).startOf('day').diff(dayjs(event.startAt).startOf('day'), 'day');
    return Math.max(0, days);
}

export function openRemindersOf(events: TypeEvent[], now: Date): TypeEvent[] {
    const until = dayjs(now).endOf('day').toDate();
    return events
        .filter((event) => isOpenReminder(event, until))
        .sort((a, b) => Date.parse(a.startAt) - Date.parse(b.startAt) || a.title.localeCompare(b.title));
}

export function lateLabel(days: number): string | null {
    if (days <= 0) return null;
    if (days === 1) return 'da ieri';
    return `da ${days} giorni`;
}
